<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box input_left">
      <div class="select-label">账单月份:</div>
      <DatePicker v-model="time" type="month" placeholder="请选择订单月份"  style="width: 100px" />
      <DatePicker v-model="timeEnd" type="month" placeholder="请选择订单月份"  style="width: 100px" />
    </div>
    <div class="select-box input_left_two">
      <div class="select-label">提现状态:</div>
      <Select v-model="txStatus" style="width:100px" @on-change="changeTx">
        <Option :value="0" >未提现</Option>
        <Option :value="1" >提现中</Option>
        <Option :value="2" >提现完成</Option>
      </Select>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn"  style="margin-right:5px;">查询</Button>
    </div>
    <div class="bills_tip_box">
      <h4 class="tip">结算流程及注意事项</h4>
      <p class="tip">1.每当有付费应用产生订单，基于分成合同比例，该订单金额的70%为相应佣金</p>
      <p class="tip">2.以月为单位进行汇总结算，当月订单未发生退款则被记为该月的“有效返佣订单”</p>
      <p class="tip">3.每个月2-7日可对此前有效佣金进行汇总提现（月度结算累计超过500元），申请提现的佣金将在当月到账</p>
      <p class="tip">4.如果已经结算佣金的订单发生退款，将在操作退款的月度进行扣减</p>
    </div>
    <div>
      <Button type="primary" @click="withdraw">提现</Button>
      <Button type="primary" @click="showPayMent">收款信息</Button>
    </div>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="isShowPayMent"
      title="收费信息"
      @on-ok="applyData('formPayValidate')">
      <Form ref="formPayValidate" :model="formPayValidate" :label-width="120">
        <FormItem label="收款人姓名" prop="name">
          <Input v-model="formPayValidate.name" :disabled="true" placeholder="请输入收款人姓名" />
        </FormItem>
        <FormItem label="收款人身份证号" prop="idno">
          <Input v-model="formPayValidate.idno" :disabled="true" placeholder="请输入收款人身份证号" />
        </FormItem>
        <FormItem label="收款人手机号" prop="mobile">
          <Input v-model="formPayValidate.mobile" :disabled="true" placeholder="请输入收款人手机号" />
        </FormItem>
        <FormItem label="开户行" prop="bank">
          <Input v-model="formPayValidate.bank" placeholder="请输入开户行" />
        </FormItem>
        <FormItem label="银行卡号" prop="bank_no">
          <Input v-model="formPayValidate.bank_no" placeholder="请输入银行卡号" />
        </FormItem>
      </Form>
    </Modal>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
export default {
  name: 'testUsers',
  data () {
    return {
      loading: true,
      time: '',
      timeEnd: '',
      tableLoading: true,
      appList: [],
      txStatus: 0,
      formPayValidate: {
        bank: '',
        bank_no: '',
        name: '',
        mobile: '',
        idno: ''
      },
      isShowPayMent: false,
      columns: [ // table表格
        {
          title: '账单月份',
          key: 'orderNo',
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '付款单号',
          key: 'businessName',
          align: 'center',
          minWidth: 200
        },
        {
          title: '订单数',
          align: 'center',
          key: 'updateDate',
          minWidth: 100
        },
        {
          title: '收入合计（元）',
          align: 'center',
          key: 'brand',
          minWidth: 100
        },
        {
          title: '佣金金额（元）',
          align: 'center',
          key: 'purchAmount',
          minWidth: 100
        },
        {
          title: '提现状态',
          align: 'center',
          key: 'incomeRate',
          minWidth: 100,
          render: (h, params) => {
            let text = ''
            if (params === 0) {
              text = '未提现'
            } else if (params === 1) {
              text = '提现中'
            } else if (params === 2) {
              text = '提现完成'
            }
            return text
          }
        },
        {
          title: '操作',
          align: 'center',
          key: 'incomeMoney',
          minWidth: 100,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                  }
                }
              }, '收款信息')
            ])
          }
        }
      ],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      // return
    }
    this.getDay()
    setTimeout(() => {
      this.loadData()
    }, 500)
  },
  methods: {
    // 加载tabs列表
    searchBtn () {
      this.loadData()
    },
    showPayMent () {
      this.isShowPayMent = true
      this.getQualification()
    },
    applyData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let params = this.formPayValidate
          https.request({
            method: 'put',
            url: '/v2/es/account/qualification/payment/info',
            params: params
          }).then(res => {
            this.$Message.success('修改成功!')
          })
        }
      })
    },
    getQualification () {
      https.request({
        method: 'get',
        url: '/v2/es/account/qualification'
      }).then(res => {
        if (res.data) {
          console.log(res.data)
          this.formPayValidate = {
            name: res.data.name,
            mobile: res.data.mobile,
            idno: res.data.idno,
            bank: res.data.bank,
            bank_no: res.data.bank_no
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    withdraw () {
      this.getAccount()
    },
    getAccount () {
      https.request({
        method: 'GET',
        url: '/v2/es/account',
        params: {}
      }).then(res => {
        this.getAppList(res.id)
      })
    },
    getAppList (id) {
      let params = {
        page_size: 100,
        page: 1,
        uid: id
      }
      https.request({
        method: 'get',
        url: 'v2/es/apps',
        params: params
      }).then(res => {
        let arr = []
        res.data.items.map(item => {
          if (item.store_pkg_name.length > 0) {
            arr.push({
              store_pkg_name: item.store_pkg_name
            })
          }
        })
        https.request({
          method: 'post',
          url: '/v2/es/income/withdraw',
          data: {
            store_pkg_name: ''
          }
        }).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.$Message.success('提现成功')
          }
        }).catch(error => {
          console.log(error)
        })
      })
    },
    changeTx (val) {
      this.txStatus = val
    },
    loadData () {
      // if (this.time.length === 0) {
      //   this.$Message.error('请选择查询日期')
      //   return
      // }
      console.log(this.time)
      let params = {
        page: this.current,
        page_size: this.pageSize,
        status: this.txStatus,
        s_date: '',
        e_date: ''
      }
      let year = this.time.getFullYear()
      let month = this.time.getMonth() + 1 < 10 ? `0${this.time.getMonth() + 1}` : this.time.getMonth() + 1
      let yearE = this.timeEnd.getFullYear()
      let monthE = this.timeEnd.getMonth() + 1 < 10 ? `0${this.timeEnd.getMonth() + 1}` : this.timeEnd.getMonth() + 1
      params.s_date = `${year}-${month}`
      params.e_date = `${yearE}-${monthE}`
      console.log(params)
      https.request({
        method: 'get',
        url: '/v2/es/income/bills',
        params: params
      }).then(res => {
        this.dataList = res.data || []
        this.tableLoading = false
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    getDay () {
      let today = new Date()
      this.time = this.getlastMonth()
      this.timeEnd = today
    },
    getlastMonth () {
      let now = new Date()
      let nowDate = now.getDate()
      let lastMonth = new Date(now.getTime())
      lastMonth.setMonth(lastMonth.getMonth())
      lastMonth.setDate(0)
      let daysOflastMonth = lastMonth.getDate()
      lastMonth.setDate(nowDate > daysOflastMonth ? daysOflastMonth : nowDate)
      return lastMonth
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .spacingTwice{
    margin-top:30px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
    .input_left{
    // left:516px;
    left:131px;
  }
  .input_left_two{
    // left:700px;
    left:588px;
  }
  .input_left_three{
    // left:885px;
    left:781px;
  }
  .input_left_four{
    left:369px;
  }
  .bills_tip_box{
    background:rgba(255, 255, 128, 0.12941176470588237);
    color:#7f7f7f;
    padding-top:30px;
    padding-bottom:30px;
    margin-top:60px;
  }
  .tip{
    line-height: 30px;
    margin-left:30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/bills.vue